import dayjs from "dayjs"

const EPOCH = dayjs("2020-05-01")

const useEpoch = () => {
  return EPOCH
}

export default useEpoch
